const CONFIG = {
  BASE_URL: 'https://restaurant-api.dicoding.dev/',
  BASE_IMAGE_SMALL_URL: 'https://restaurant-api.dicoding.dev/images/small/',
  BASE_IMAGE_MEDIUM_URL: 'https://restaurant-api.dicoding.dev/images/medium/',
  BASE_IMAGE_LARGE_URL: 'https://restaurant-api.dicoding.dev/images/large/',
  CACHE_NAME: 'resto',
  DATABASE_NAME: 'mitahu-Resto-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'restaurants',
};

export default CONFIG;
